module.exports = __webpack_public_path__ + "media/Background_Removal.d71cb8c4.webm";